import { ChampCompteRendu } from '../compte-rendu/champ-compte-rendu.model';
import { CreneauType } from '../../app.constants';
import { ISite } from './site.interface';
import { VacationIntervention } from '../vacation/vacation-intervention.model';
import { Consigne } from './consigne.model';
import { Site } from './site.model';
import { ICreneauInter } from './creneau-inter.interface';

export class CreneauIntervention implements ICreneauInter {
  constructor(
    public readonly id: string,
    public readonly geolocEnabled: boolean,
    public readonly site: ISite | undefined,
    public vacation?: VacationIntervention,
    public readonly consignes: Consigne[] = [],
    public readonly materiel?: string[],
    public readonly signatureEnabled = false,
    public readonly champsPersonnalises: ChampCompteRendu[] = [],
    public readonly type = CreneauType.INTERVENTION
  ) {}

  public static hydrate(creneau: CreneauIntervention): CreneauIntervention {
    return new CreneauIntervention(
      creneau.id,
      creneau.geolocEnabled,
      creneau.site ? Site.hydrate(creneau.site) : undefined,
      creneau.vacation ? VacationIntervention.hydrate(creneau.vacation) : undefined,
      creneau.consignes?.length > 0 ? creneau.consignes.map(Consigne.hydrate) : [],
      Object.assign([], creneau.materiel),
      creneau.signatureEnabled,
      creneau.champsPersonnalises ? creneau.champsPersonnalises.map(ChampCompteRendu.hydrate) : [],
      creneau.type
    );
  }

  public getSiteLibelle(): string {
    return this.vacation?.site?.libelle ?? '';
  }
}
